'use strict';

angular.module('imagetrend.components')
    .controller('hlpSupplementalTrainingController', ['$scope', '$rootScope', '$window', '$q', '$uibModal', 'Levels', 'LicenseRequestSupplementalTrainingTrainings', 'Trainings', 'LicenseRequests',
        function ($scope, $rootScope, $window, $q, $uibModal, Levels, LicenseRequestSupplementalTrainingTrainings, Trainings, LicenseRequests) {

        $scope.trainingsLoading = true;
        $scope.levelsLoading = false;
        $scope.trainingLevels = [];
        $scope.certification_levels = null;
        $scope.application_type = null;
        var promises = [];

        if ($scope.parameters.license_request_id != null) {
            if ($scope.component.elementAnswer == null) {
                promises.push(LicenseRequestSupplementalTrainingTrainings.get($scope.parameters).then(function (supplementalTrainings) {
                    $scope.component.elementAnswer = supplementalTrainings;
                }))
            }

            var completedTrainingParameters = angular.copy($scope.parameters);
            completedTrainingParameters.completedOnly = true;
            completedTrainingParameters.otherApplications = true;
            promises.push(Trainings.get(completedTrainingParameters).then(function (trainings) {
                $scope.trainings = trainings;
            }))

            promises.push(LicenseRequests.getTrainingValidationDates($scope.parameters).then(function (validationDates) {
                $scope.validationDates = validationDates;
            }))
        }
        else {
            $scope.component.elementAnswer = [];
        }

        $q.all(promises).then(function () {
            $scope.trainingsLoading = false;
            $scope.calculateLevels();
        }).catch(function (response) {
            // handle error
        });

        $scope.$watch("datapointAnswers['certification_application_type']", function (type) {
            if (type != null) {

                $scope.application_type = type[0].value;

                if ($scope.certification_levels != null) {
                    $scope.levelsLoading = true;
                    var cl = $scope.certification_levels;
                    Levels.get({ certification_levels: $scope.certification_levels, application_type: $scope.application_type }).then(function (levels) {
                        if (cl == $scope.certification_levels) {
                            $scope.trainingLevels = levels;
                            if (!$scope.trainingsLoading) {
                                $scope.calculateLevels();
                            }
                        }
                        $scope.levelsLoading = false;
                    })
                }
                else {
                    $scope.trainingLevels = [];
                }
            }
        }, true)

        $scope.$watch("datapointAnswers['certification_levels']", function (levels) {

            if (levels != null) {
               
                $scope.certification_levels = null;
                levels.forEach(function (answer) {

                    if (answer.value != null && angular.isString(answer.value) && answer.value != '') {
                        answer.value.split(',').forEach(function (level) {

                            if ($scope.certification_levels == null) {
                                $scope.certification_levels = level;
                            }
                            else {
                                $scope.certification_levels += ',' + level;
                            }
                        })
                    }
                    else if (answer.value != null && angular.isArray(answer.value)) {
                        answer.value.forEach(function (level) {
                            if (level != null) {
                                var l = null;
                                if (angular.isObject(level)) {
                                    l = level.id;
                                }
                                else {
                                    l = level;
                                }

                                if (l != null) {
                                    if ($scope.certification_levels == null) {
                                        $scope.certification_levels = l;
                                    }
                                    else {
                                        $scope.certification_levels += ',' + l;
                                    }
                                }
                            }
                        })
                    }
                })

                if ($scope.certification_levels != null) {
                    $scope.levelsLoading = true;
                    var cl = $scope.certification_levels;

                    Levels.get({ certification_levels: $scope.certification_levels, application_type: $scope.application_type }).then(function (levels) {
                        if (cl == $scope.certification_levels) {
                            $scope.trainingLevels = levels;
                            if (!$scope.trainingsLoading) {
                                $scope.calculateLevels();
                            }
                        }
                        $scope.levelsLoading = false;
                    })
                }
                else {
                    $scope.trainingLevels = [];
                }
            }
        }, true)

        $scope.editTraining = function (training, add, topics) {
            if (topics != null && topics.length > 0) {
                training.training_topics = [];
                training.training_topics.push({ topic_id: topics[0].id, topic_name: topics[0].name, availableoptions: topics[0].availableoptions, options: null });
            }

            $uibModal.open({
                animation: true,
                templateUrl: 'templates/supplemental-training-modal/supplemental-training-modal.html',
                controller: 'SupplementTrainingModalController',
                size: 'lg',
                resolve: {
                    training: function () {
                        if (training.training_topics != null) {
                            training.training_topics.forEach(function (topic) {
                                topic.options = [];
                                if (topic.selected_options != null) {
                                    topic.selected_options.split(',').forEach(function (option) {
                                        topic.options.push({ id: option });
                                    })
                                }
                            })
                        }

                        return training;
                    }
                }
            }).result.then(function (t) {
                if (t != null && t.training_topics != null) {
                    t.training_topics.forEach(function (training_topic) {
                        training_topic.selected_options = null;
                        if (training_topic.options != null) {
                            training_topic.options.forEach(function (option) {
                                if (training_topic.selected_options == null) {
                                    training_topic.selected_options = option.id;
                                }
                                else {
                                    training_topic.selected_options += ',' + option.id;
                                }
                            })
                        }
                    })
                }

                if (add) {
                    $scope.component.elementAnswer.push(t);
                }
                else {
                    training = t;
                }

                $scope.calculateLevels();
            })
        }

        $scope.removeTraining = function (array, item) {
            array.splice(array.indexOf(item), 1);
            $scope.calculateLevels();
        }

        $scope.dateCheck = function (training) {
            return !($scope.validationDates == null || ($scope.validationDates.start_date == null || training.end_date >= $scope.validationDates.start_date) && ($scope.validationDates.end_date == null || training.end_date <= $scope.validationDates.end_date));
        }

        $scope.calculateLevels = function () {
            $scope.trainingLevels.forEach(function (level) {
                level.complete = true;
                level.override_complete = false;
                level.required_requirement_hours = 0;
                level.required_requirement_flex_hours = 0;
                level.completed_hours = 0;
                level.used_hours = 0;
                level.completed_flex_hours = 0;
                level.used_flex_hours = 0;
                level.used_requirement_flex_hours = 0;
                level.missingFlexRequirements = false;

                level.requirements.forEach(function (requirement) {
                    requirement.complete = true;
                    requirement.completed_hours = 0;
                    requirement.used_hours = 0;
                    requirement.required_topic_hours = 0;
                    requirement.completed_flex_hours = 0;
                    requirement.used_flex_hours = 0;

                    requirement.topics.forEach(function (topic) {
                        topic.complete = true;
                        topic.completed_hours = 0;
                        topic.used_hours = 0;
                        topic.selected_options = [];

                        $scope.component.elementAnswer.forEach(function (training) {
                            if (($scope.validationDates.start_date == null || training.end_date >= $scope.validationDates.start_date) && ($scope.validationDates.end_date == null || training.end_date <= $scope.validationDates.end_date)) {
                                training.training_topics.forEach(function (training_topic) {
                                    if (topic.id == training_topic.topic_id) {
                                        if (training_topic.selected_options != null) {
                                            training_topic.selected_options.split(',').forEach(function (option) {
                                                if (topic.selected_options.indexOf(option) < 0) {
                                                    topic.selected_options.push(option);
                                                }
                                            })
                                        }
                                        topic.completed_hours += training_topic.completed_hours;
                                    }
                                })
                            }
                        })

                        $scope.trainings.forEach(function (training) {
                            training.training_topics.forEach(function (training_topic) {
                                if (topic.id == training_topic.topic_id) {
                                    if (training_topic.selected_options != null) {
                                        training_topic.selected_options.split(',').forEach(function (option) {
                                            if (topic.selected_options.indexOf(option) < 0) {
                                                topic.selected_options.push(option);
                                            }
                                        })
                                    }
                                    topic.completed_hours += training_topic.completed_hours;
                                }
                            })
                        })

                        if (topic.max_hours > 0 && topic.completed_hours > topic.max_hours) {
                            topic.all_hours = topic.completed_hours;
                            topic.completed_hours = topic.max_hours;
                        }

                        if (topic.completed_hours > topic.required_hours) {
                            topic.used_hours = topic.required_hours;
                        }
                        else {
                            topic.used_hours = topic.completed_hours;
                        }

                        if (topic.used_hours < topic.required_hours) {
                            topic.complete = false;
                            requirement.complete = false;
                            level.complete = false;
                        }
                        topic.remaining_hours = topic.required_hours - topic.used_hours;
                        if (topic.remaining_hours < 0) {
                            topic.remaining_hours = 0;
                        }

                        requirement.completed_hours += topic.completed_hours;
                        //requirement.used_hours += topic.used_hours;
                        requirement.required_topic_hours += topic.required_hours;
                    })

                    if (requirement.completed_hours > requirement.required_hours) {
                        requirement.used_hours = requirement.required_hours;
                    }
                    else {
                        requirement.used_hours = requirement.completed_hours;
                    }

                    // determine if requirement failed
                    if (requirement.used_hours < requirement.required_hours) {
                        requirement.complete = false;
                        level.complete = false;
                    }
                    requirement.remaining_hours = requirement.required_hours - requirement.used_hours;
                    if (requirement.remaining_hours < 0) {
                        requirement.remaining_hours = 0;
                    }

                    // calculate flex hours
                    requirement.required_flex_hours = requirement.required_hours - requirement.required_topic_hours;
                    if (requirement.required_flex_hours < 0) {
                        requirement.required_flex_hours = 0;
                    }
                    requirement.completed_flex_hours = requirement.completed_hours - requirement.required_topic_hours;
                    if (requirement.completed_flex_hours < 0) {
                        requirement.completed_flex_hours = 0;
                    }
                    if (requirement.completed_flex_hours > requirement.required_flex_hours) {
                        requirement.used_flex_hours = requirement.required_flex_hours;
                    }
                    else {
                        requirement.used_flex_hours = requirement.completed_flex_hours;
                    }
                    if (requirement.used_flex_hours < 0) {
                        requirement.used_flex_hours = 0;
                    }
                    requirement.remaining_flex_hours = requirement.required_flex_hours - requirement.used_flex_hours;
                    if (requirement.remaining_flex_hours < 0) {
                        requirement.remaining_flex_hours = 0;
                    }
                    if (requirement.used_flex_hours < requirement.required_flex_hours) {
                        requirement.complete = false;
                        level.complete = false;
                    }

                    // handle override
                    if (requirement.override && requirement.complete) {
                        level.override_complete = true;
                    }

                    level.completed_hours += requirement.completed_hours;
                    level.completed_flex_hours += requirement.completed_flex_hours;
                    level.used_requirement_flex_hours += requirement.used_flex_hours;
                    level.used_hours += requirement.used_hours;
                    level.required_requirement_hours += requirement.required_hours;
                    level.required_requirement_flex_hours += requirement.required_flex_hours;
                })

                level.remaining_hours = level.required_requirement_hours - level.used_hours;
                if (level.remaining_hours < 0) {
                    level.remaining_hours = 0;
                }

                if (level.override_complete) {
                    level.complete = true;
                }

                // level flex hours
                if (level.override_required_flex_hours && level.required_flex_hours > 0 && level.required_flex_hours > level.required_requirement_flex_hours) {
                    level.required_flex_hours_actual = level.required_flex_hours;
                    level.remaining_flex_hours = level.required_flex_hours - level.completed_flex_hours;
                    if (level.remaining_flex_hours < 0) {
                        level.remaining_flex_hours = 0;
                    }
                    if (level.completed_flex_hours > level.required_flex_hours) {
                        level.used_flex_hours = level.required_flex_hours;
                    }
                    else {
                        level.used_flex_hours = level.completed_flex_hours;
                    }
                    if (level.used_flex_hours < 0) {
                        level.used_flex_hours = 0;
                    }

                    if (level.used_flex_hours < level.required_flex_hours) {
                        level.complete = false;
                    }

                    if (level.required_requirement_flex_hours - level.used_requirement_flex_hours > 0) {
                        if ((level.required_requirement_flex_hours - level.used_requirement_flex_hours) > level.remaining_flex_hours) {
                            level.remaining_flex_hours = level.required_requirement_flex_hours - level.used_requirement_flex_hours;
                        }
                        level.missingFlexRequirements = true;
                    }
                }
                else {
                    level.required_flex_hours_actual = level.required_requirement_flex_hours;
                    level.used_flex_hours = level.used_requirement_flex_hours;
                    level.remaining_flex_hours = level.required_requirement_flex_hours - level.used_requirement_flex_hours;
                    if (level.remaining_flex_hours < 0) {
                        level.remaining_flex_hours = 0;
                    }
                }

                //determines the value of the training requirements and corresponding validation trigger
                level.hasRequirements = (level.requirements.length > 0) ? true : false;
                if (level.hasRequirements == false) {
                    level.hasRequirements = (level.required_flex_hours > 0) ? true : false;
                }
            })
        }

        $scope.openDocument = function (id, code) {
            $window.open($rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + id.toUpperCase() + '&code=' + code, '_blank');
        }
    }])
    .directive('hlpSupplementalTraining', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/supplemental-training/supplemental-training.html',
            replace: true,
            controller: 'hlpSupplementalTrainingController',
            scope: {
                parameters: '=?',
                component: '=?',
                datapointAnswers: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;